import React from "react";
import { Link } from "gatsby";
import "tachyons";

export default ({ message }) => (
  <div className="bg-light-gray lh-copy serif pa2 tc-l center flex flex-column justify-center f4">
    <p>
      We are happy to guide you through the process of investing in real estate
      and building wealth…
    </p>
    <Link
      to="/investors"
      class="f6 link dim ph3 mw5 center tc-l pv2 mb2 dib white bg-black"
    >
      Schedule a Call
    </Link>
  </div>
);
